import useUrl from './helpers/useUrl'

/** @param {import("@nuxtjs/axios").NuxtAxiosInstance} client */
export default (client) => {
  const root = useUrl('bankid')
  return {

    /** @returns {Promise<AxiosResponse<GetVerificationProviderStatusResponse>>} */
    getBankIdStatus() {
      const url = root('service_status')
      return client.get(url)
    },
    /** @returns{Promise<AxiosResponse<GetDeeplinkResponse>>} */
    getDeeplinkBankid() {
      const url = root('deeplink')
      return client.get(url)
    },

    // WARN: Calls not performed
    getUserStatusBankid() {
      const url = root('user_status')
      return client.get(url)
    },
  }
}
